"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LobTitle_1 = require("./LobTitle");
exports.default = LobTitle_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LobTitle/index.js
// module id = 800
// module chunks = 8